import 'css-chunksrc/client/common/projectsSelection/zones/zone/projects/project/styles.scss';export default {
  "project": "_project_1l0l9_1",
  "icon": "_icon_1l0l9_11",
  "name": "_name_1l0l9_19"
};